import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Layout } from './components/layout/Layout';
import LandingPage from './components/LandingPage';
import './index.css';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('A cél DOM elem (root) nem található.');
}
const root = ReactDOM.createRoot(rootElement);
root.render(_jsx(React.StrictMode, { children: _jsx(Layout, { pageTitle: "Kezd\u0151lap", activePage: "landing", children: _jsx(LandingPage, {}) }) }));
